module.exports = __webpack_public_path__ + "img/12.502438ee.jpg";